import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TaskFishImport from "@/components/v2/Tasks/FishImport/index.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'OverviewView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TaskFishImport, { viewMode: "overview" }))
}
}

})